import styled from 'styled-components';
import { tablet768, desktop1024 } from '@nubank/nuds-web/styles/breakpoints';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

import addWebpBackgroundImage, { handleNotSupportedWebp } from 'styles/addWebpBackgroundImage';

export const HeadingBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 1.5rem 1.5rem 2.5rem;
  min-height: calc(100vh - 14rem);
  background-color: ${nuDSColor('primary')};
  ${addWebpBackgroundImage('woman-holding-card-smiling/woman-holding-card-smiling@0.5x.jpg')}
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  ${tablet768`
    justify-content: flex-start;
    padding: 0;
    min-height: 60vh;

    &,
    ${handleNotSupportedWebp`
      background-image: none;
      background-color: transparent;
    `}
  `}

  ${desktop1024`
    flex: 1;
    align-items: flex-start;
    justify-content: center;
    min-height: calc(100vh - 8rem);
    margin-bottom: 0;
  `}
`;

HeadingBlock.displayName = 'HeadingBlock';
